import { AppActionTypes } from 'src/actions/appActions';
import {
  ChallengeDetail,
  IAction,
  IBrand,
  IBreadCrumb,
  ICategory,
  IChallenges,
  IContentPage,
  IMenu,
  ISalesforceCenter,
  ISignInData,
  ISpecialty,
  ITag,
  IState,
  IStaticPageConfig,
  ICampaign,
} from 'src/shared/models';
import { IScanError } from 'src/shared/models/scan.model';
import { IDataScan } from 'src/shared/models/scanData.model';
import { appTypes } from 'src/types/appTypes';

export interface AppState {
  actions: IAction[] | null;
  brandList: IBrand[] | null;
  breadCrumbs: IBreadCrumb[];
  categoryList: ICategory[] | null;
  challenge: ChallengeDetail;
  challenges: IChallenges;
  publicMenu: IMenu[] | null; //TODO: REMOVE
  salesforceCenter: ISalesforceCenter | null;
  shoppingProducts: [] | null;
  signInData: ISignInData | null;
  specialtyList: ISpecialty[] | null;
  tagList: ITag[] | null;
  stateList: IState | null;
  staticPageConfig: IStaticPageConfig;
  userHome: IContentPage | null;
  userMenu: IMenu[] | null; //TODO: REMOVE
  platformStatus: boolean | null;
  isFooterSticky: string;
  firstCompletedProfile: boolean;
  scanError: IScanError;
  fromScan: boolean;
  scanData: IDataScan;
  userCampaigns: ICampaign;
  showDiscoveryModal: boolean;
  showSpecialDiscoveryCoupon: boolean;
  showStaticPageDiscoveryModal: boolean;
}

const initialState: AppState = {
  actions: null,
  brandList: null,
  breadCrumbs: [],
  categoryList: null,
  challenge: null,
  challenges: {
    donations: [],
    trainings: [],
    events: [],
    campaigns: [],
    experiences: [],
    contests: [],
    formations: [],
  },
  publicMenu: null,
  salesforceCenter: null,
  shoppingProducts: null,
  signInData: null,
  specialtyList: null,
  stateList: null,
  tagList: null,
  userHome: null,
  userMenu: null,
  staticPageConfig: null,
  platformStatus: null,
  isFooterSticky: null,
  firstCompletedProfile: false,
  scanError: null,
  fromScan: false,
  scanData: {
    fromLoggedDiScan: false,
    fromLogin: false,
    fromScan: false,
    welcome: false,
    consumable: null,
    userConsumableCoupon: [],
    couponConsumables: null,
    newCoupon: null,
    qrInfo: null,
  },
  userCampaigns: null,
  showDiscoveryModal: false,
  showSpecialDiscoveryCoupon: false,
  showStaticPageDiscoveryModal: false,
};

export function appReducer(
  state = initialState,
  action: AppActionTypes,
): AppState {
  switch (action.type) {
    case appTypes.APP_FETCH_BRANDS:
    case appTypes.APP_FETCH_CATEGORIES:
    case appTypes.APP_FETCH_PUBLIC_MENU:
    case appTypes.APP_FETCH_SPECIALTIES:
    case appTypes.APP_FETCH_SHOPPING_PRODUCTS:
    case appTypes.APP_FETCH_STATES:
    case appTypes.APP_FETCH_TAGS:
    case appTypes.APP_FETCH_USER_HOME:
    case appTypes.APP_FETCH_USER_MENU:
    case appTypes.APP_SET_BREADCRUMBS:
    case appTypes.APP_SET_CHALLENGE:
    case appTypes.APP_SET_SALESFORCE_CENTER:
    case appTypes.APP_SET_STATIC_PAGE:
    case appTypes.APP_SET_PLATFORM_STATUS:
    case appTypes.APP_SET_COMPLETED_PROFILE_USER:
    case appTypes.APP_SET_FOOTER_HEIGHT:
    case appTypes.APP_SET_ACTIONS:
    case appTypes.APP_SET_SCAN_ERROR:
    case appTypes.APP_SET_FROM_SCAN:
    case appTypes.APP_DATA_SCAN:
    case appTypes.APP_SET_CAMPAIGN:
    case appTypes.APP_SET_SHOW_DISCOVERY_MODAL:
    case appTypes.APP_SET_SHOW_SPECIAL_DISCOVERY_COUPON:
    case appTypes.APP_SET_STATIC_PAGE_DISCOVERY_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case appTypes.APP_FETCH_EMBRACE_PRACTICES:
    case appTypes.APP_FETCH_LIWW_PRACTICES:
    case appTypes.APP_FETCH_USA_PRACTICES:
      return {
        ...state,
        signInData: { ...state.signInData, ...action.payload },
      };
    case appTypes.APP_UPDATE_CHALLENGES:
      return {
        ...state,
        challenges: { ...state.challenges, ...action.payload },
      };
    default:
      return state;
  }
}
